module.exports = __webpack_public_path__ + "static/media/inrs.1ae0d431.png";